import React from "react";
import ContentLoader from "react-content-loader";

const UserListLoader = () => {
  const data = [1, 2, 3, 4, 5];

  return (
    <div className="py-2.5 bg-black">
      {data.map((item) => (
        <div
          key={item}
          className="flex items-center px-5 py-3.75 border-b border-[#333333] border-opacity-50"
        >
          <ContentLoader
            speed={2}
            width={400}
            height={75}
            viewBox="0 0 400 75"
            backgroundColor="#333333"
            foregroundColor="#4a4a4a"
          >
            {/* Avatar */}
            <circle cx="40" cy="37.5" r="30" />
            {/* Chat Info Lines */}
            <rect x="90" y="20" rx="4" ry="4" width="150" height="10" />
            <rect x="90" y="45" rx="4" ry="4" width="100" height="10" />
          </ContentLoader>
        </div>
      ))}
    </div>
  );
};

export default UserListLoader;
